<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <div class="spinner" *ngIf="isLoading; else ISpage"></div>
  <ng-template #ISpage>
    <section>
      <div class="content-wrapper title">
        <h1>International student</h1>
      </div>
      <div class="content-wrapper">
        <div class="separator"></div>
        <div class="is-card-container">
          <img
            class="mobile-background"
            [src]="pageData.header_image_web.data.attributes.url"
          />
          <div class="is-card-image-wrapper">
            <div class="is-card">
              <div class="heading">
                <!-- Title -->
                <h2>{{ university.pathway_provider_title }}</h2>

                <!-- Policy Number -->
                <p>
                  Policy no: {{ university.pathway_provider_policy_number }}
                </p>
              </div>
              <!-- Disclaimer box -->
              <div class="disclaimer">
                <p>{{ university.pathway_provider_disclaimer }}</p>
              </div>
            </div>
            <div
              class="web-image-header"
              [style.background-image]="
                'url(' + pageData.header_image_web.data.attributes.url + ')'
              "
            ></div>
          </div>

          <div class="policy-section">
            <div class="overview">
              <app-render-markdown
                [content]="university.pathway_provider_overview!"
              ></app-render-markdown>
            </div>

            <div class="docs-wrapper">
              <a
                class="policy-button"
                *ngIf="policyIPIDDocUrl"
                [href]="policyIPIDDocUrl"
                target="_blank"
                >IPID</a
              >

              <a
                class="policy-button"
                *ngIf="policyWordingDocUrl"
                [href]="policyWordingDocUrl"
                target="_blank"
                >Policy Wording</a
              >

              <a
                class="policy-button"
                *ngIf="policyStatementOfInsuranceDocUrl"
                [href]="policyStatementOfInsuranceDocUrl"
                target="_blank"
                >Statement of Insurance</a
              >
            </div>

            <!-- Policy Summary link -->
            <a class="policy-summary-link" (click)="policySummaryNavigate()">{{
              pageData.policy_summary_title
            }}</a>
          </div>
        </div>

        <!-- International Student policy section -->
      </div>
    </section>
    <!-- Make a claim section -->
    <app-make-a-claim></app-make-a-claim>
    <section class="student-life">
      <!-- Student life banner -->
      <app-student-life-banner
        [showBanner]="pageData.show_student_life_banner ?? false"
        [banner]="pageData.student_life_banner.data.attributes"
      ></app-student-life-banner>
    </section>
  </ng-template>
</div>
